import AppConfig from './app-config';

export { AppConfig };
